var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticStyle:{"width":"700px","max-width":"700px"}},[_c('faqs',{attrs:{"faqs":_vm.faqs,"active-tab":_vm.activeTab,"available-languages":_vm.availableLanguages,"show-faqs-usage":_vm.showFaqsUsage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }